
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $40c46fa9e80b240a$exports = {};

$parcel$export($40c46fa9e80b240a$exports, "spectrum", function () { return $40c46fa9e80b240a$export$3311ab3a441bc141; }, function (v) { return $40c46fa9e80b240a$export$3311ab3a441bc141 = v; });
$parcel$export($40c46fa9e80b240a$exports, "spectrum--dark", function () { return $40c46fa9e80b240a$export$68dc111a79481afd; }, function (v) { return $40c46fa9e80b240a$export$68dc111a79481afd = v; });
$parcel$export($40c46fa9e80b240a$exports, "spectrum--darkest", function () { return $40c46fa9e80b240a$export$4ecdba604f5f1f44; }, function (v) { return $40c46fa9e80b240a$export$4ecdba604f5f1f44 = v; });
$parcel$export($40c46fa9e80b240a$exports, "spectrum--large", function () { return $40c46fa9e80b240a$export$a88a8dbe29386d31; }, function (v) { return $40c46fa9e80b240a$export$a88a8dbe29386d31 = v; });
$parcel$export($40c46fa9e80b240a$exports, "spectrum--light", function () { return $40c46fa9e80b240a$export$efb37c2f79da8163; }, function (v) { return $40c46fa9e80b240a$export$efb37c2f79da8163 = v; });
$parcel$export($40c46fa9e80b240a$exports, "spectrum--lightest", function () { return $40c46fa9e80b240a$export$baaa804dc80cce18; }, function (v) { return $40c46fa9e80b240a$export$baaa804dc80cce18 = v; });
$parcel$export($40c46fa9e80b240a$exports, "spectrum--medium", function () { return $40c46fa9e80b240a$export$4c0c83b3f4303ef8; }, function (v) { return $40c46fa9e80b240a$export$4c0c83b3f4303ef8 = v; });
var $40c46fa9e80b240a$export$3311ab3a441bc141;
var $40c46fa9e80b240a$export$68dc111a79481afd;
var $40c46fa9e80b240a$export$4ecdba604f5f1f44;
var $40c46fa9e80b240a$export$a88a8dbe29386d31;
var $40c46fa9e80b240a$export$efb37c2f79da8163;
var $40c46fa9e80b240a$export$baaa804dc80cce18;
var $40c46fa9e80b240a$export$4c0c83b3f4303ef8;
$40c46fa9e80b240a$export$3311ab3a441bc141 = `XhWg9q_spectrum`;
$40c46fa9e80b240a$export$68dc111a79481afd = `XhWg9q_spectrum--dark`;
$40c46fa9e80b240a$export$4ecdba604f5f1f44 = `XhWg9q_spectrum--darkest`;
$40c46fa9e80b240a$export$a88a8dbe29386d31 = `XhWg9q_spectrum--large`;
$40c46fa9e80b240a$export$efb37c2f79da8163 = `XhWg9q_spectrum--light`;
$40c46fa9e80b240a$export$baaa804dc80cce18 = `XhWg9q_spectrum--lightest`;
$40c46fa9e80b240a$export$4c0c83b3f4303ef8 = `XhWg9q_spectrum--medium`;


export {$40c46fa9e80b240a$exports as default};
//# sourceMappingURL=vars_spectrum-global_css.mjs.map
